// extracted by mini-css-extract-plugin
module.exports = {"bannervideo":"bannervideo_bannervideo__TMR_n"};